import React, { FC } from 'react';
import styles from '#modules/profileSelection/profilelist/profile-item/ProfileItem.module.scss';
import { avatarSource } from '#config';
import classNames from 'classnames';
import { UserProfile } from '#types';
import ProfileItemLabel from '#modules/profileSelection/profilelist/profile-item/ProfileItemLabel';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  profile: UserProfile;
  selected?: boolean;
  mode?: 'edit' | 'select';
  deletable?: boolean;
  onSelect?: (profile: UserProfile) => void;
  onDelete?: (profile: UserProfile) => void;
  onClick?: (profile: UserProfile) => void;
  icon?: JSX.Element;
};

const ProfileItem: FC<Props> = ({
  profile,
  mode,
  deletable = true,
  selected = false,
  onSelect,
  onDelete,
  onClick,
  icon,
}) => {
  const { id, avatarAssetId, name } = profile;

  const { t } = useTranslation();

  const blockClass = classNames(styles.host, {
    [styles.isButtonEdit]: mode === 'edit',
  });

  const avatarImage = avatarSource(avatarAssetId, '256w');

  const handleChange = () => {
    onSelect?.(profile);
  };

  const handleDelete = () => {
    onDelete?.(profile);
  };

  const handleOnClick = () => {
    onClick?.(profile);
  };

  return (
    <div className="tw-text-center tw-inline-block">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
      <label className={blockClass} onClick={handleOnClick}>
        <input
          type="radio"
          value={id}
          className={styles.input}
          onChange={handleChange}
          checked={selected}
        />
        <span className={styles.media} data-testid="profile-selection">
          {avatarImage && (
            <img className={styles.mediaInner} alt="" src={avatarImage} />
          )}
        </span>
        {!!icon && <span className={styles.icon}>{icon}</span>}
        <ProfileItemLabel
          label={name}
          classes={
            'tw-whitespace-nowrap tw-overflow-hidden tw-overflow-ellipsis'
          }
        />
      </label>

      {mode === 'edit' && deletable && (
        <button
          className={styles.buttonDelete}
          type="button"
          title={t('deleteUser')}
          onClick={handleDelete}
        />
      )}
    </div>
  );
};

export default ProfileItem;
